module.exports = __webpack_public_path__ + "img/icon-3.3b4d4e7b.png";